import { formatMomentToValueDate } from '../../../helpers/formatMomentToValueDate';
import { formatValueDateToMoment } from '../../../helpers/formatValueDateToMoment';
import { values } from '@morf/proto/values/v1/values_ts_proto';

export const goToPrevWeek = (date: values.v1.Date): values.v1.Date => {
  const prevWeekMoment = formatValueDateToMoment(date).subtract(1, 'week');
  return formatMomentToValueDate(prevWeekMoment);
};
